<template>
    <div class="recipe-items-lines">
        <div class="col-6 recipe-item-line d-flex align-items-center mb-1"
             v-for="(selectedItem, index) in selectedItems"
             :key="index"
        >
            <button type="button" class="btn btn-danger d-inline-block mr-1" @click="removeRecipeItem(index)">
                <i class="fas fa-minus"></i>
            </button>
            <RecipeItemLine
                class="d-inline-block"
                :field-id="arrayName + '-' + index"
                :field-name="arrayName + '[' + index + ']'"
                :items="items"
                :value="selectedItem"
            />
        </div>

        <div>
            <button type="button" class="btn btn-primary" @click="addRecipeItem">
                <i class="fas fa-plus"></i> Ajouter
            </button>
        </div>
    </div>
</template>

<script>
import {v4 as uuidv4} from 'uuid';

import RecipeItemLine from "./RecipeItemLine"

export default {
    name: 'RecipeItemsLines',

    components: {
        RecipeItemLine,
    },

    props: {
        arrayName: {
            type: String,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
        value: {
            type: Array|Object,
            required: false,
        },
    },

    data() {
        let selectedItemsKeyed = {};
        if (this.value) {
            for (const selectedItemKey in this.value) {
                selectedItemsKeyed[uuidv4()] = this.value[selectedItemKey];
            }
        }

        return {
            selectedItems: selectedItemsKeyed,
        }
    },

    methods: {
        addRecipeItem() {
            this.$set(this.selectedItems, uuidv4(), {});
        },

        removeRecipeItem(removedIndex) {
            this.$delete(this.selectedItems, removedIndex);
        },
    },
}
</script>

<style scoped lang="scss">

</style>
